import React from 'react';
//import ReactDOM from 'react-dom';
import { Waypoint } from 'react-waypoint';
import { withStyles } from '@material-ui/core/styles';
import FullscreenIcon from '@material-ui/icons/Fullscreen';

const styles = theme => ({
  zoom: {
    position: 'absolute',
    zIndex: 1,
    right: 0,
    bottom: 0,
    fontSize: '3rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    color: '#fff'
  },
  waypoint: {
    position: 'absolute',
    left: 0,
    top: '-10vh'
  }
});

class Image extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      resolution: 0,
      src: null
    }
  }

  componentDidMount() {
    //let e = ReactDOM.findDOMNode(this);
    //console.log(e);
  }

  load() {
    if (!this.state.src) {
      const { fadeIn, attrs, delay } = this.props;

      if (fadeIn) {
        setTimeout(() => this.setState({visible: true, src: attrs.photo.thumb_url}), delay);
      } else {
        //this.setState({visible: true, resolution: 2, src: attrs.photo.preview_url_small});
        this.setState({visible: true, resolution: 0, src: attrs.photo.thumb_url});
      }
    }
  }

  nextSrc() {
    const { attrs } = this.props;

    switch (this.state.resolution) {
      //case 0:
      //  return attrs.photo.thumb_url_large;
      //case 1:
      //  return attrs.photo.preview_url_small;
        //case 2:
        //  return attrs.photo.preview_url;
      default:
        return null;
    }
  }

  loadSrc(src) {
    return new Promise(resolve => {
      fetch(src)
      .then(resp => resp.blob())
      .then(blob => {
        let reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    });
  }

  onLoad(event) {
    if (this.state.src) {
      let nextSrc = this.nextSrc();

      if (nextSrc) {
        this.loadSrc(nextSrc)
        .then(src => this.setState({src: src, resolution: this.state.resolution + 1}));
      }
    }
  }

  render() {
    const {
      classes,
      theme,
      attrs,
      selected,
      viewImage,
      enableSelect,
      toggleSelect
      //visible
    } = this.props;

    const Checkmark = ({ selected }) => (
      <div
        style={
          selected
          ? { left: "4px", top: "4px", position: "absolute", zIndex: "1" }
          : { display: "none" }
        }
      >
        <svg
          style={{ fill: "white", position: "absolute" }}
          width="24px"
          height="24px"
        >
        <circle cx="12.5" cy="12.2" r="8.292" />
        </svg>
        <svg
          style={{ fill: "#06befa", position: "absolute" }}
          width="24px"
          height="24px"
        >
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
      </div>
    );

    const imgStyle = {
      transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
      border: '2px solid #fff'
    };

    const selectedImgStyle = {
      transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
      transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
      border: '2px solid #fff'
    };

    let cont = {
      //backgroundColor: "#eee",
      cursor: "pointer",
      overflow: "hidden",
      position: "relative",
      transition: 'opacity 0.2s'
    };

    const sx = (100 - (30 / attrs.photo.width) * 100) / 100;
    const sy = (100 - (30 / attrs.photo.height) * 100) / 100;
    selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

    if (attrs.direction === "column") {
      cont.position = "absolute";
      cont.left = attrs.left;
      cont.top = attrs.top;
    }

    let fullscreenIcon = null;
    if (this.props.enableViewImage) {
      fullscreenIcon = (
        <FullscreenIcon className={classes.zoom} onClickCapture={viewImage.bind(this)} />
      );
    }

    let imgAttrs = { ...attrs.photo };
    if (this.props.fadeIn && !this.state.visible) {
      //imgAttrs.src = attrs.photo.thumb_url;
      cont.opacity = 0;

    } else {
      cont.opacity = 1;
      //switch (this.state.resolution) {
      //  case 0:
      //    imgAttrs.src = attrs.photo.thumb_url_large;
      //    cont.opacity = 1;
      //    break;
      //  case 1:
      //    imgAttrs.src = attrs.photo.src;
      //    cont.opacity = 1;
      //}
    }

    let onClick = null;
    if (this.props.onClick) {
      onClick = event => this.props.onClick(event, attrs.photo);
    }
    if (enableSelect) {
      onClick = toggleSelect.bind(this);
    }

    // show image sequence number on hover
    let sequenceNumber = attrs.photo.position + 1;

    return (
      <div
        style={{ borderRadius: '3px', margin: '2px', height: attrs.photo.height, width: attrs.photo.width, ...cont }}
        className={selected ? "not-selected" : ""}
      >
        <Waypoint className={classes.waypoint} onEnter={this.load.bind(this)} />
        <Checkmark selected={selected} />
        {fullscreenIcon}
        <img
          style={
            selected ? { ...imgStyle, ...selectedImgStyle } : { ...imgStyle }
          }
          {...imgAttrs}
          onClick={onClick}
          onLoad={this.onLoad.bind(this)}
          title={sequenceNumber}
        />
        <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Image);

